import { sendAiRequest } from './aiRequests';
import { buildDocFromTemplate } from '../components/Texteditor/tiptapTemplateBuilders';
import { saveWorksheet } from './worksheetsApi';

export async function regenerateWorksheet({ userId, request, title, style = 'clean', layout, working, requestId, worksheetId, previousVersion, onStage = () => {} }) {
  if (!worksheetId) throw new Error('Save the worksheet before regenerating.');
  const { data } = await sendAiRequest('/generate', request, { requestId, action: 'regenerate', onRetry: ({ retry, maxRetries }) => onStage(`Generation interrupted. Retrying (${retry}/${maxRetries})`) });
  if (!Array.isArray(data.questions) || !data.questions.length) throw new Error('No questions were returned. Please try again.');
  onStage('Preparing your worksheet');
  const content = { ...buildDocFromTemplate('exam-style', data.questions, title), worksheetMeta: {
    style, layout, working, settings: request, generationId: data.generation_id || null, ...(data.quality?{quality:data.quality}:{}), previousVersion,
  } };
  const { data: saved, error } = await saveWorksheet({ id: worksheetId, userId, templateId: 'exam-style',
    title, sourcePrompt: request.prompt, content });
  if (error || !saved?.id) throw new Error('The replacement could not be saved. Your current worksheet is still available.');
  return saved.id;
}
